import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const LearningHub = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Learning Hub";

  const title = "Learning Hub";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.05, // Delay for each letter
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> Learning Hub | Money Service Business Advocacy UK</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="Learning Hub | Money Service Business Advocacy UK "
        />
        <meta property="og:description" content="" />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{
                    display: "inline-block",
                    marginRight: letter === " " ? "0.3rem" : "0",
                    whiteSpace: "pre",
                  }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Learning Hub</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="row gy-8">
              <div className="col-lg-6 d-flex">
                {/* learning Box Start */}
                <div
                  className="learning-box mb-2 learning-bg-2 w-100 d-flex flex-column justify-content-between aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration={1000}
                >
                  <div className="row gy-4 gy-sm-0 align-items-center">
                    <div className="col-md-6">
                      <NavLink to="/how-to-series">
                        <div className="learning-video">
                          <div className="glightbox">
                            <div className="learning-video__image">
                              <img
                                src="assets/images/how-to-series/How-to-Series.jpg"
                                alt="How to Series?"
                              />
                            </div>
                          </div>
                        </div>
                      </NavLink>
                    </div>
                    <div className="col-md-6">
                      <div className="learning-caption-02">
                        <NavLink to="/how-to-series">
                          <h3 className="learning-caption-02__title">
                            How-To Series?
                          </h3>
                        </NavLink>
                        <p className="mb-0">
                          Our "How-To" series is your go-to guide for running a
                          compliant and successful money service business.
                        </p>
                        <NavLink
                          to="/how-to-series"
                          className="learning-caption-02__btn btn btn-primary btn-hover-secondary"
                        >
                          View Articles
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
                {/* learning Box End */}
              </div>

              <div className="col-lg-6 d-flex">
                {/* learning Box Start */}
                <div
                  className="learning-box mb-2 learning-bg-2 w-100 d-flex flex-column justify-content-between aos-init aos-animate"
                  data-aos="fade-up"
                  data-aos-duration={1000}
                >
                  <div className="row gy-4 gy-sm-0 align-items-center">
                    <div className="col-md-6">
                      <NavLink to="/webinars">
                        <div className="learning-video">
                          <div className="glightbox">
                            <div className="learning-video__image">
                              <img
                                src="assets/images/how-to-series/Webinars.jpg"
                                alt="Webinars"
                              />
                            </div>
                          </div>
                        </div>
                      </NavLink>
                    </div>
                    <div className="col-md-6">
                      <div className="learning-caption-02">
                        <NavLink to="/webinars">
                          <h3 className="learning-caption-02__title">
                            Webinars
                          </h3>
                        </NavLink>
                        <p className="mb-0">
                          Stay ahead with expert-led sessions on industry
                          insights, skills, and innovation
                        </p>
                        <NavLink
                          to="/webinars"
                          className="learning-caption-02__btn btn btn-primary btn-hover-secondary"
                        >
                          View Webinars
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
                {/* learning Box End */}
              </div>
            </div>

            {/* subscribe Box Start */}
            <div className="row align-items-center subscribe-section mt-5 d-none">
              {/* Left Section */}
              <div className="col-md-3 subscribe-box">
                <div className="subscribe-img">
                  <img src="assets/images/subscribe.png" alt="subscribe" />
                </div>
              </div>
              {/* Right Section (Illustration) */}
              <div className="col-md-9">
                <div className="p-1 text-center">
                  <h4 className="fw-bold text-primary">
                    Subscribe for Newsletter
                  </h4>
                  <div className="row justify-content-center">
                    <div className="col-lg-6">
                      <form className="d-flex mt-3">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Enter your email"
                          required
                          style={{ borderRadius: "1rem 0rem 0rem 1rem" }}
                        />
                        <button
                          className="btn btn-primary btn-subscribe"
                          type="submit"
                        >
                          Subscribe
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* subscribe Box End */}
          </div>
        </section>
      </main>
    </div>
  );
};

export default LearningHub;
